import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
export const ActivityCalendarDate = ({ number, isChecked, isPrevChecked, isNextChecked, isToday, freezeUsed, onClick, }) => {
    const streakPrevChecked = isChecked && isPrevChecked;
    const streakNextChecked = isChecked && isNextChecked;
    const handleClick = () => {
        if (!onClick)
            return;
        onClick(number);
    };
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement("div", { className: css(styles.spacer, streakPrevChecked && styles.spacerColor) }),
        React.createElement("span", { className: css(streakPrevChecked && isToday && styles.numberColorBuckground) },
            React.createElement("span", { className: css(styles.number, isToday && styles.isToday, isChecked && (isToday ? styles.isTodayWatched : styles.watchedNumber), freezeUsed && styles.freezeUsed, streakPrevChecked && !isToday && styles.hasPrevWatched, streakNextChecked && styles.hasNextWatched, onClick && styles.clickable), onClick: handleClick }, number)),
        React.createElement("div", { className: css(styles.spacer, streakNextChecked && styles.spacerColor) })));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        display: 'flex',
        fontSize: 14,
        fontWeight: 'bold',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '4px 0',
        textAlign: 'center',
        width: 'calc(100% / 7)',
    },
    number: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 20,
        height: 27,
        width: 27,
    },
    numberColorBuckground: {
        backgroundColor: Colors.OrangeLight,
        borderRadius: '0 20px 20px 0',
    },
    watchedNumber: {
        backgroundColor: Colors.OrangeLight,
        color: Colors.Orange,
        cursor: 'pointer',
    },
    hasNextWatched: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
    },
    hasPrevWatched: {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
    },
    spacer: {
        flex: 1,
        width: '100%',
        height: '100%',
    },
    spacerColor: {
        backgroundColor: Colors.OrangeLight,
    },
    isToday: {
        backgroundColor: Colors.Gray,
        color: Colors.White,
    },
    isTodayWatched: {
        backgroundColor: Colors.Orange,
        cursor: 'pointer',
    },
    freezeUsed: {
        color: Colors.Blue,
    },
    clickable: {
        cursor: 'pointer',
    },
});
